<span class="key-icon {{ kind }} size-{{ size }} theme-{{ theme }}">
  <icon [set]="set" [name]="icon" class="key-icon-glyph" />
</span>
